import { OffersPriceComponent } from './offers-price.component';

import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ offersPrice: OffersPriceComponent });
